import React from 'react';
import Icon from '../../../../../../../../../../../../../../../../components/icon/index';
import {connect} from 'react-redux';
import {
    checkUpdates,
    flash,
    getChangedStatus,
    getDeletedCollaborators,
    updateCollaborators
} from '../../../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';

class DeleteCollaborator extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			toRemove: this.props.findCollaborators.collaborators[this.props.index].toRemove
		};

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e){

		let cTarget = e.currentTarget;

		this.props.checkUpdates();

		if(this.props.flash){
			this.props.setFlash(null);
		}

		this.setState((state) => ({
			toRemove : !state.toRemove
		}),() => {

			if(this.state.toRemove) {
				cTarget.parentNode.parentNode.classList.add("is-deleting");
			} else {
				cTarget.parentNode.parentNode.classList.remove("is-deleting");
			}

			let contributorsToUpdate = [];
			let {updateCollaborators, collaboratorId} = this.props;
			let newCollaboratorToUpdate = true;

			if(this.props.updateCollaborators.length > 0){

				this.props.findCollaborators.collaborators.forEach(collaborator => {
					updateCollaborators.forEach(updateCollaborator => {

						if(collaborator.id === updateCollaborator.id){

							/*
							*  Collaborator is inside the collaborators to update
							* */

							if(updateCollaborator.id === collaboratorId){

								newCollaboratorToUpdate = false;

								/*
								*  Collaborator is the one we have clicked on
								* */

								let collaboratorToUpdate = {
									groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
									id: updateCollaborator.id,
									email: updateCollaborator.email,
									permission: updateCollaborator.permission,
									type: updateCollaborator.type,
									addToContact: updateCollaborator.addToContact,
									toRemove: this.state.toRemove,
								};

								if (
									collaborator.id === collaboratorToUpdate.id &&
									collaborator.email === collaboratorToUpdate.email &&
									collaborator.permission === collaboratorToUpdate.permission &&
									collaborator.type === collaboratorToUpdate.type &&
									collaborator.addToContact === collaboratorToUpdate.addToContact &&
									collaborator.toRemove === collaboratorToUpdate.toRemove
								){

									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.id !== updateCollaborator.id)
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								} else {
									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.id !== updateCollaborator.id),
										collaboratorToUpdate
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								}
							}

						}
					});

					if(newCollaboratorToUpdate){
						if (collaborator.id === collaboratorId) {
							this.props.setUpdateCollaborators(
								[
									...updateCollaborators,
									{
										groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
										id: collaborator.id,
										email: collaborator.email,
										permission: collaborator.permission,
										type: collaborator.type,
										addToContact: collaborator.addToContact,
										toRemove: this.state.toRemove,
									}
								]
							)

						}
					}

				});

			} else {

				this.props.findCollaborators.collaborators.forEach(collaborator => {

					if (collaborator.id === collaboratorId) {
						this.props.setUpdateCollaborators([{
							groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
							id: collaborator.id,
							email: collaborator.email,
							permission: collaborator.permission,
							type: collaborator.type,
							addToContact: collaborator.addToContact,
							toRemove: this.state.toRemove,
						}])

					}

				})
			}
		})
	}

	render() {
		if(this.props.ownershipChangeTarget === this.props.collaboratorId){
			return (
				<Icon
					id={this.props.collaboratorId}
					className="delete-collaborator disabled"
					name="trash"
				/>
			)
		} else {

			return (
				<Icon
					id={this.props.collaboratorId}
					className="delete-collaborator"
					onClick={this.handleClick}
					name="trash"
				/>
			)
		}

	}
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		flash : state.sharingDetailsReducer.flash,
		ownershipChangeTarget : state.sharingDetailsReducer.ownershipChangeTarget,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getDeletedCollaborators : (boolean) => {
			dispatch(getDeletedCollaborators(boolean))
		},
		getChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
        checkUpdates : () => {
            dispatch(checkUpdates())
        },
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
		setFlash : (array) => {
			dispatch(flash(array))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCollaborator);
